import { type FC, type ReactNode } from "react";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import * as styles from "./styles.css";

type Props = {
  children: ReactNode;
  className?: string;
  isShow: boolean;
};

export const BottomFixedBar: FC<Props> = ({ children, className, isShow }) => {
  return (
    <div
      className={`${styles.bottomFixedBarContainer} ${className || ""}`}
      style={assignInlineVars({
        [styles.transform]: isShow ? "" : "translateY(100%)",
      })}
    >
      {children}
    </div>
  );
};
